import React from 'react';
import { summarySummaryVFTextareaFieldData } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/summary-v-f-textarea.css';

const SummaryVFTextarea = React.memo(({
  fieldData,
}) => {

  const {
    fieldTitle,
    displayValues,
  } = fieldData;

  return (
    <div className="summary-field-v-f-textarea">
      <p className="field-title">
        {fieldTitle}
      </p>
      <p className="field-value">
        {displayValues}
      </p>
    </div>
  );
});

SummaryVFTextarea.propTypes = {
  fieldData: summarySummaryVFTextareaFieldData,
};

export { SummaryVFTextarea };

